export default __webpack_public_path__ + "static/media/u-shaped.e7c390ff.svg";